export default "__VITE_ASSET__COEbQUqs__"